import type { ChangeEvent } from 'react';
import { SliderLabels } from './components/SliderLabels';
import type { SliderTrackBandInput } from './utils';
import { sliderNormaliseBands, sliderTrackBandColor } from './utils';
import { parseNumberSafe } from '../../../Narrative/utils';
import { InputRange } from './components/InputRange';

type Props = {
  id: string;
  value: number;
  precision: number;
  minRange: number;
  maxRange: number;
  bands?: SliderTrackBandInput[];
  onChange: (value: number) => void;
  onInteraction?: (isInteracting: boolean) => void;
};

export const SliderWithLabels = ({
  value,
  precision,
  onChange,
  minRange,
  maxRange,
  id,
  bands,
  onInteraction,
}: Props) => {
  const handleSliderChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onChange(parseNumberSafe(e.target.value, precision));
  };

  const normalisedBands = sliderNormaliseBands(
    bands,
    minRange,
    maxRange,
    'var(--s-color-p-white-170)'
  );

  return (
    <div className="grid gap-x1">
      <InputRange
        id={id}
        min={minRange}
        max={maxRange}
        step="1"
        value={value}
        onChange={handleSliderChange}
        onPointerDown={() => onInteraction?.(true)}
        onPointerUp={() => onInteraction?.(false)}
        trackColor={sliderTrackBandColor(normalisedBands)}
      />

      <SliderLabels bands={normalisedBands} />
    </div>
  );
};
